<div class="p-20 fx-row fx-wrap align-items-start justify-content-start text-center">
  <span class="title fx-flex-100 mb-10  text-center">{{ data.titleKey | translate }}</span>
  <div class="text fx-flex-100 text-center" [innerHTML]="data.text"></div>
  <div class="w-100 fx-row align-items-center justify-content-between mt-10">
    <label class="text dark">
      {{ "UPLOAD_DOCUMENT.CHOOSE_ANALYSIS_MODE" | translate }}
    </label>
    <app-select [label]="'UPLOAD_DOCUMENT.ANALYSIS_MODE' | translate" [options]="analysisModes" [(value)]="analysis"
      [matTooltip]="analysis ? ('UPLOAD_DOCUMENT.ANALYSIS_MODE_'+ analysis +'_HINT' | translate) : ''"></app-select>
  </div>
  <mat-divider class="fx-flex-100 mv-10"></mat-divider>
  <div class="fx-row align-items-center justify-content-center fx-flex-100">
    <button class="button fx-flex mr-10" (click)="onCancel()">{{ 'ACTIONS.CANCEL' | translate }}</button>
    <button class="main-button fx-flex ml-10" (click)="onConfirm()" [class.disabled]="isDisabled"
      [disabled]="isDisabled">{{ 'ACTIONS.REANALYZE' | translate }}</button>
  </div>
</div>